import SEO from "./SEO";
import SEOConfig from "./SEOConfig";

// The WebSite and SportsOrganization nodes live statically in public/index.html, so crawlers
// without JavaScript see them too. They are not redeclared here.
//
// The home page leads with the brand, so it takes a complete title instead of the
// "<page> | brand" template. It positions the league as a formula / open-wheel league, the
// query it should win. Titles and headings spell the sport "симрейсинг"; SEO.jsx adds both
// spellings to the keywords.
const HomeSEO = () => {
  const { siteUrl } = SEOConfig;

  const keywords = [
    "Slick Racing Ukraine",
    "віртуальний автоспорт",
    "iRacing",
    "українська ліга",
    "автосимулятор",
    "гоночна спільнота",
    "Discord",
    "формульна ліга",
    "open wheel",
    "open wheel ліга",
    "formula league",
    "open wheel league Ukraine",
    "Ukrainian sim racing league",
    "ліга iRacing",
  ];

  return (
    <SEO
      fullTitle="Slick Racing Ukraine — формульна ліга симрейсингу в iRacing"
      description="Українська формульна ліга симрейсингу в iRacing: open wheel чемпіонати Formula 4, Super Formula Lights, FF1600. Розклад, результати, таблиці, пілоти."
      url={siteUrl}
      canonical={siteUrl}
      keywords={keywords}
      lang="uk"
      type="website"
    />
  );
};

export default HomeSEO;
